import { Text } from '../text/text';
import { Flex } from '../flex/flex';
import { Checkbox, CheckboxProps } from './checkbox';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { useId } from 'react';

export type CheckboxWithLabelProps = CheckboxProps & {
  label?: string | null;
  containerStyle?: React.CSSProperties;
};

export const CheckboxWithLabel = (props: CheckboxWithLabelProps) => {
  const { label, containerStyle, id, ...rest } = props;
  const generatedId = useId();
  const checkboxId = id || generatedId;
  return (
    <Flex css={{ alignItems: 'center', gap: themeVars.pad[12], ...containerStyle }}>
      <Checkbox {...rest} id={checkboxId} />
      {label && (
        <Text as="label" variant="body1" htmlFor={checkboxId}>
          {label}
        </Text>
      )}
    </Flex>
  );
};
